/**
 * @flow
 * @relayHash 85a726d92bf626c1d93d20640cb1b21b
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AdoptedSystemDocumentTemplatesQueryVariables = {|
  after?: ?string,
  first?: ?number,
  sort?: ?string,
|};
export type AdoptedSystemDocumentTemplatesQueryResponse = {|
  +adoptedSystemDocumentTemplates: ?{|
    +adoptedSystemDocumentTemplates: ?{|
      +totalCount: ?number,
      +edges: $ReadOnlyArray<?{|
        +node: ?{|
          +pk: ?number,
          +name: ?string,
          +total: ?number,
          +adopted: ?number,
        |}
      |}>,
    |},
    +error: ?{|
      +statusCode: ?number
    |},
    +otherTabTotal: ?number,
  |}
|};
export type AdoptedSystemDocumentTemplatesQuery = {|
  variables: AdoptedSystemDocumentTemplatesQueryVariables,
  response: AdoptedSystemDocumentTemplatesQueryResponse,
|};
*/


/*
query AdoptedSystemDocumentTemplatesQuery(
  $after: String
  $first: Int
  $sort: String
) {
  adoptedSystemDocumentTemplates(sort: $sort) {
    adoptedSystemDocumentTemplates(after: $after, first: $first) {
      totalCount
      edges {
        node {
          pk
          name
          total
          adopted
        }
      }
    }
    error {
      statusCode
    }
    otherTabTotal
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "after",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "first",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "sort",
    "type": "String",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "adoptedSystemDocumentTemplates",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "sort",
        "variableName": "sort",
        "type": "String"
      }
    ],
    "concreteType": "AdoptedSystemDocumentTemplateListType",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "adoptedSystemDocumentTemplates",
        "storageKey": null,
        "args": [
          {
            "kind": "Variable",
            "name": "after",
            "variableName": "after",
            "type": "String"
          },
          {
            "kind": "Variable",
            "name": "first",
            "variableName": "first",
            "type": "Int"
          }
        ],
        "concreteType": "AdoptedSystemDocumentTemplatesConnection",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "totalCount",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "AdoptedSystemDocumentTemplatesEdge",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "AdoptedSystemDocumentTemplateType",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "pk",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "name",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "total",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "adopted",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "error",
        "storageKey": null,
        "args": null,
        "concreteType": "ErrorType",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "statusCode",
            "args": null,
            "storageKey": null
          }
        ]
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "otherTabTotal",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "AdoptedSystemDocumentTemplatesQuery",
  "id": "d9596f3426d71fb0a97d14b0a0077ada",
  "text": null,
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "AdoptedSystemDocumentTemplatesQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "AdoptedSystemDocumentTemplatesQuery",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
node.text = "query AdoptedSystemDocumentTemplatesQuery(\n  $after: String\n  $first: Int\n  $sort: String\n) {\n  adoptedSystemDocumentTemplates(sort: $sort) {\n    adoptedSystemDocumentTemplates(after: $after, first: $first) {\n      totalCount\n      edges {\n        node {\n          pk\n          name\n          total\n          adopted\n        }\n      }\n    }\n    error {\n      statusCode\n    }\n    otherTabTotal\n  }\n}\n";
(node/*: any*/).hash = '92114dcbc8847d43ef14eaff2dd66f18';
module.exports = node;
